import { render, staticRenderFns } from "./DescriptionOffers.vue?vue&type=template&id=787ad644&scoped=true"
import script from "./DescriptionOffers.vue?vue&type=script&lang=ts"
export * from "./DescriptionOffers.vue?vue&type=script&lang=ts"
import style0 from "./DescriptionOffers.vue?vue&type=style&index=0&id=787ad644&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787ad644",
  null
  
)

export default component.exports